module.exports = __webpack_public_path__ + "media/images/flags/64/Bangladesh-de5ac93ab90a0899fd09ed9753941658.png";